import React, { useState } from 'react'
import { ref, set, onValue, push, remove, update, query, orderByChild, equalTo } from 'firebase/database'
import database from './base'

const useFirebase = () => {
    const [entreprises, setEntreprises] = useState([])
    const [profil, setProfil] = useState([])
    const [staff, setStaff] = useState([])
    const [services, setServices] = useState([])
    const [datesOff, setDatesOff] = useState([])
    const [booking, setBooking] = useState([])
    const [clients, setClients] = useState([])
    const [count, setCount] = useState(0)
    const [tokens, setTokens] = useState([])
    const [messagesPush, setMessagesPush] = useState([])
    const [messagesChat, setMessagesChat] = useState([])
    const [dataWhere, setDataWhere] = useState([])
    
    const readData = (keyUid) => {
        readDataEntreprises()
        readDataProfil(keyUid)
        readDataServices(keyUid)
        readDataStaff(keyUid)
        readDatesOff(keyUid)
        readDataBooking(keyUid)
        readDataClients(keyUid)
        setCount(1)
    }

    // PROFIL
    const readDataEntreprises = () => {
        setEntreprises([])
        const starCountRef = ref(database, '/entreprises')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setEntreprises(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // PROFIL
    const readDataProfil = (keyUid) => {
        setProfil([])
        const starCountRef = ref(database, 'entreprises/'+keyUid)
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setProfil(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // booking
    const readDataBooking = (keyUid) => {
        setBooking([])
        const starCountRef = ref(database, 'entreprises/'+keyUid+'/booking')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setBooking(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // CLIENTS
    const readDataClients = (keyUid) => {
        setClients([])
        const starCountRef = ref(database, 'entreprises/'+keyUid+'/clients')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setClients(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    const readDataStaff = (keyUid) => {
        setStaff([])
        const starCountRef = ref(database, 'entreprises/'+keyUid+'/staff')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setStaff(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    const readDatesOff = (keyUid) => {
        setDatesOff([])
        const starCountRef = ref(database, 'entreprises/'+keyUid+'/datesOff')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setDatesOff(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // SERVICES
    const readDataServices = (keyUid) => {
        setServices([])
        const starCountRef = ref(database, 'entreprises/'+keyUid+'/services')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setServices(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // TOKENS
    const readDataTokens = (keyUid) => {
        setTokens([])
        const starCountRef = ref(database, '/entreprises/'+keyUid+'/tokens')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setTokens(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // MESSAGES PUSH
    const readDataMessagesPush = (keyUid) => {
        setMessagesPush([])
        const starCountRef = ref(database, '/entreprises/'+keyUid+'/messagesPush')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setMessagesPush(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // MESSAGES PUSH
    const readDataMessagesChat = (keyUid) => {
        setMessagesChat([])
        const starCountRef = ref(database, '/entreprises/'+keyUid+'/messagesChat')
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                const dataList = []
                for (let id in data) {
                  dataList.push({id,...data[id]})
                }
                setMessagesChat(dataList)
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        }
    }

    // WRITE DATA 
    const writeData = (id,data) => {
        try {
            const postListRef = ref(database, '/' + id)
            const newPostRef = push(postListRef)
            set(newPostRef, data)
        } catch {
            console.log('Il y a une erreur dans l ecriture')
        }
    }

    // DELETE DATA 
    const deleteData = (id) => {
        const todoRef = ref(database, '/' + id)
        remove(todoRef)  
    }

    // UPDATE DATA 
    const updateData = (id,data) => {
        console.log('userFirebase updateData ')
        const todoRef = ref(database, '/' + id)
        update(todoRef, data)
    }

    // GET ELEMENT
    const _getDataWhere = (folder,id,child,res) => {
        const array = []
        const starCountRef = query(ref(database, 'entreprises/'+id+'/'+folder), orderByChild(child),  equalTo(res))
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                for (let id in data) {
                    array.push({id,...data[id]})
                }
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        } 
        return array
    }

    return { 
        writeData, 
        readData, 
        deleteData, 
        updateData, 
        readDataTokens, 
        readDataMessagesPush, 
        readDataMessagesChat,
        readDataClients,
        _getDataWhere,
        messagesPush, 
        entreprises, 
        profil, 
        staff, 
        services, 
        datesOff, 
        booking, 
        clients, 
        tokens, 
        count,
        messagesChat,
        dataWhere,
    }
}

export default useFirebase 

